function setTabs() {
    const titles = document.querySelectorAll('.tab__title');
    titles.forEach(title => {
        title.addEventListener('click', (event) => {
            const tabId = event.target.getAttribute('data-id');
            showTab(tabId);
        });
    });
}

function showTab(tabId) {
    // Remove active and open classes from all titles and contents
    const titles = document.querySelectorAll('.tab__title');
    const contents = document.querySelectorAll('.tab__content');
    titles.forEach(title => {
        title.classList.remove('active');
    });
    contents.forEach(content => {
        content.classList.remove('open');
    });

    // Add active class to the clicked title and open class to the corresponding content
    document.querySelectorAll(`.tab__title[data-id="${tabId}"]`).forEach(title => {
      title.classList.add('active');
    });
    document.querySelector(`.tab__content[data-id="${tabId}"]`).classList.add('open');
}

document.addEventListener('DOMContentLoaded', () => {
  setTabs();
});